import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const ClassifiedSupplierListing = () => {
  const { id } = useParams(); // Get classified_id from URL
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    axios
      .get(`https://backend-zkgn.onrender.com/api/suppliers/by-classified/${id}`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setSuppliers(res.data);
        } else {
          setSuppliers([]); // fallback to empty array if not
        }
      })
      .catch((err) => {
        console.error("Error fetching suppliers:", err);
        setSuppliers([]); // fallback on error
      });
  }, [id]);
  return (
    <div className="container-fluid my-5">
      <div className="text-left mb-4">
        <h5 className="fw-bold text-tertiry">
          <strong>{suppliers.length}</strong> - Suppliers Found
        </h5>
      </div>
      <div className="row">
        {suppliers.map((supplier, index) => (
          <div className="col-lg-4 col-md-6 mb-4" key={index}>
            <div className="card shadow-sm supplier-card">
              <div className="card-body">
                <h5 className="card-title mb-2">
                  <Link
                    to={`/supplier/${
                      supplier.supplier_id
                    }/${supplier.supplier_name.replace(/\s+/g, "-")}`}
                    className="supplier-link"
                  >
                    <strong>{supplier.supplier_name}</strong>
                  </Link>
                </h5>
                <p className="card-text plantdetails mb-1">
                  <span className="label">Address:</span> {supplier.address}
                </p>
                <p className="card-text plantdetails mb-1">
                  <span className="label">We are providers of:</span>{" "}
                  {supplier.providers_of}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClassifiedSupplierListing;
